import type { StagedFieldsGroupFormField } from '../typings';

/** True for a staged group the provider must add an entry to, as the server's RequiresAnEntry decides. */
export const requiresAnEntry = ({
  isRequired,
  minItems,
}: Pick<StagedFieldsGroupFormField, 'isRequired' | 'minItems'>): boolean =>
  isRequired || (minItems ?? 0) > 0;
